export default __webpack_public_path__ + "static/digital_consultant-18ce471f590a2fff4ff57216c3bb8de2.png";